import { useEffect, EffectCallback } from 'react';

/**
 * 客制 hooks life cycle
 * 用於在組件的首次渲染完成後執行特定的副作用函式。
 * 相當於 `componentDidMount` 的效果，只會在組件首次渲染時觸發一次。
 *
 * @param effect 要執行的副作用函式。
 */
export default function useDidMount(effect: EffectCallback): void {
  return useEffect(effect, []);
}
